/** Status of a bank account */
export const BankAccountState = {
  /** Bank account is approved and can be used for payouts */
  Approved: 'APPROVED',
  /** Bank account is newly created, not yet approved */
  Created: 'CREATED',
  /** Bank account has been rejected and cannot be used */
  Rejected: 'REJECTED',
} as const

export type BankAccountState = (typeof BankAccountState)[keyof typeof BankAccountState]
export const DonationConfigWordings = {
  Formal: 'FORMAL',
  Informal: 'INFORMAL',
  InformalGeneric: 'INFORMAL_GENERIC',
} as const

export type DonationConfigWordings = (typeof DonationConfigWordings)[keyof typeof DonationConfigWordings]
export const DonationIntervals = {
  Monthly: 'MONTHLY',
  Single: 'SINGLE',
  Yearly: 'YEARLY',
} as const

export type DonationIntervals = (typeof DonationIntervals)[keyof typeof DonationIntervals]
/** State of a FundraisingEvent */
export const FundraisingEventState = {
  Activated: 'ACTIVATED',
  Blocked: 'BLOCKED',
  Closed: 'CLOSED',
  Spam: 'SPAM',
} as const

export type FundraisingEventState = (typeof FundraisingEventState)[keyof typeof FundraisingEventState]
export const LegacyDonationIntervals = {
  HalfYearly: 'HALF_YEARLY',
  Monthly: 'MONTHLY',
  QuarterYearly: 'QUARTER_YEARLY',
  Single: 'SINGLE',
  Yearly: 'YEARLY',
} as const

export type LegacyDonationIntervals = (typeof LegacyDonationIntervals)[keyof typeof LegacyDonationIntervals]
export const MatchingEventCampaignTypes = {
  Absolute: 'ABSOLUTE',
  Proportional: 'PROPORTIONAL',
  Spendenmarathon: 'SPENDENMARATHON',
  Verdopplungsaktion: 'VERDOPPLUNGSAKTION',
} as const

export type MatchingEventCampaignTypes = (typeof MatchingEventCampaignTypes)[keyof typeof MatchingEventCampaignTypes]
export const PaymentMethods = {
  DirectDeposit: 'DIRECT_DEPOSIT',
  DummyPayment: 'DUMMY_PAYMENT',
  Paypal: 'PAYPAL',
  StripeApplePay: 'STRIPE_APPLE_PAY',
  StripeCc: 'STRIPE_CC',
  StripeGooglePay: 'STRIPE_GOOGLE_PAY',
  StripeSepaDebit: 'STRIPE_SEPA_DEBIT',
  StripeWero: 'STRIPE_WERO',
} as const

export type PaymentMethods = (typeof PaymentMethods)[keyof typeof PaymentMethods]
/** State of a Payout */
export const PayoutState = {
  Approved: 'APPROVED',
  Created: 'CREATED',
  InPayout: 'IN_PAYOUT',
  NotPaidOut: 'NOT_PAID_OUT',
  OnHold: 'ON_HOLD',
  PaidOut: 'PAID_OUT',
  Rejected: 'REJECTED',
  Requested: 'REQUESTED',
  Revoked: 'REVOKED',
} as const

export type PayoutState = (typeof PayoutState)[keyof typeof PayoutState]
/** Indicates where the component will be used */
export const PostdonationMessageUsecaseTypes = {
  /** Used within an iframe */
  Iframe: 'iframe',
  /** Used in the main platform */
  Platform: 'platform',
} as const

export type PostdonationMessageUsecaseTypes =
  (typeof PostdonationMessageUsecaseTypes)[keyof typeof PostdonationMessageUsecaseTypes]
/** State of a Project */
export const ProjectState = {
  Activated: 'ACTIVATED',
  Blocked: 'BLOCKED',
  Closed: 'CLOSED',
  Preparing: 'PREPARING',
  Proposed: 'PROPOSED',
} as const

export type ProjectState = (typeof ProjectState)[keyof typeof ProjectState]
export const ReceiverTypes = {
  FundraisingEvent: 'FUNDRAISING_EVENT',
  Project: 'PROJECT',
} as const

export type ReceiverTypes = (typeof ReceiverTypes)[keyof typeof ReceiverTypes]
export const RecurringIntervals = {
  HalfYearly: 'HALF_YEARLY',
  Monthly: 'MONTHLY',
  QuarterYearly: 'QUARTER_YEARLY',
  Yearly: 'YEARLY',
} as const

export type RecurringIntervals = (typeof RecurringIntervals)[keyof typeof RecurringIntervals]
export const TaxExemptionStateTypes = {
  InReview: 'IN_REVIEW',
  Outdated: 'OUTDATED',
  Valid: 'VALID',
} as const

export type TaxExemptionStateTypes = (typeof TaxExemptionStateTypes)[keyof typeof TaxExemptionStateTypes]
export const UseCaseTypes = {
  /** Use case for bank account proof uploads */
  BankAccountProof: 'bank_account_proof',
  /** Use case for donation alert audio uploads */
  DonationAlertAudio: 'donation_alert_audio',
  /** Use case for donation alert image uploads */
  DonationAlertImage: 'donation_alert_image',
  /** Use case for milestone audio uploads */
  MilestoneAudio: 'milestone_audio',
  /** Use case for milestone image uploads */
  MilestoneImage: 'milestone_image',
} as const

export type UseCaseTypes = (typeof UseCaseTypes)[keyof typeof UseCaseTypes]
export const VotingQuestionState = {
  Active: 'ACTIVE',
  Created: 'CREATED',
  Finished: 'FINISHED',
} as const

export type VotingQuestionState = (typeof VotingQuestionState)[keyof typeof VotingQuestionState]
